import React from 'react';
import {
  BookOpenCheckIcon,
  CircleCheckIcon,
  TimerResetIcon,
} from 'lucide-react';
import { motion } from 'framer-motion';

const details = [
  {
    icon: TimerResetIcon,
    label: 'Din dygnsvila',
    value: 'Dokumenteras före start',
    accent: 'text-[#67E8F9]',
  },
  {
    icon: BookOpenCheckIcon,
    label: 'Personlig tidbok',
    value: 'Tillgänglig vid kontroll',
    accent: 'text-[#FBEA87]',
  },
];

export function ComplianceVisual() {
  return (
    <motion.aside
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.42, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
      aria-label="Exempel på iVilotids pre-shiftvy"
      className="relative mx-auto w-full max-w-[460px] overflow-hidden rounded-2xl border border-[#06B6D4]/30 bg-[#0B1120] p-4 text-white shadow-[0_12px_30px_rgba(11,17,32,0.16)] sm:p-5"
    >
      <span className="absolute inset-x-0 top-0 h-px bg-[#67E8F9]/75" aria-hidden="true" />
      <div className="flex items-center justify-between gap-3 border-b border-white/10 pb-3.5">
        <div className="flex min-w-0 items-center gap-2">
          <span className="inline-flex h-2 w-2 shrink-0 rounded-full bg-[#F5C400]" aria-hidden="true" />
          <p className="truncate text-xs font-bold uppercase tracking-[0.1em] text-[#CFFAFE]">
            iVilotid · förarstart
          </p>
        </div>
        <span className="shrink-0 rounded-md border border-white/15 px-2 py-1 text-xs font-semibold text-slate-200">
          Exempelvy
        </span>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-[1.1fr_.9fr]">
        <section className="min-w-0 rounded-xl border border-[#06B6D4]/30 bg-[#102C3F] p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="text-xs font-bold uppercase tracking-[0.1em] text-[#A5F3FC]">
                Nästa steg
              </p>
              <p className="mt-1.5 font-display text-xl tracking-[-0.035em]">Starta körpass</p>
            </div>
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#06B6D4] text-[#071A28]">
              <CircleCheckIcon size={18} aria-hidden="true" />
            </span>
          </div>
          <p className="mt-5 text-sm leading-6 text-slate-100">
            En tydlig start för dagens körpass, vila och dokumentation.
          </p>
          <div className="mt-4 border-t border-[#67E8F9]/25 pt-3">
            <p className="text-sm font-semibold text-[#CFFAFE]">Status före start</p>
            <div className="mt-1.5 flex items-center gap-2 text-sm font-semibold text-white">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#06B6D4]" aria-hidden="true" />
              Redo att starta
            </div>
          </div>
        </section>
        <div className="grid gap-3">
          {details.map(({ icon: Icon, label, value, accent }) => (
            <div
              key={label}
              className="min-w-0 rounded-xl border border-white/10 bg-white/[0.04] p-3.5"
            >
              <Icon className={accent} size={17} aria-hidden="true" />
              <p className="mt-3 text-sm font-bold leading-5 text-slate-200">{label}</p>
              <p className="mt-1 text-sm font-semibold leading-6 text-white">{value}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-[#F5C400]/35 bg-[#11263B] px-3.5 py-2.5">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.08em] text-[#FEF3A7]">
            Kontrolläge
          </p>
          <p className="mt-0.5 text-sm leading-5 text-slate-200">
            Underlaget ska kunna visas vid kontroll.
          </p>
        </div>
        <span className="shrink-0 rounded-md border border-[#F5C400]/50 px-2 py-1 text-xs font-bold uppercase tracking-[0.06em] text-[#FEF3A7]">
          Skrivskyddad
        </span>
      </div>
    </motion.aside>
  );
}
